import Icon from "@anwb/poncho/components/icon";

export default function BooleanIcon({ isTrue }: { isTrue?: boolean }) {
  if (isTrue) {
    return <Icon type="ui" variant="checkbox" />;
  }
  return <Icon type="ui" variant="cross" style={{ opacity: 0.3 }} />;
}
